enum SepararValoresPor {
    //Hora = 0,
    Dia = 1,
    Mes = 2,
    Ano = 3
}

export default SepararValoresPor;